import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    baseUrl: 'https://py.loginsa.com/api_oms/api/tracking/', //<----- PRODUCCIÓN
    // baseUrl: 'http://10.15.3.174/api_oms/api/tracking/', //<----- TESTING
    token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbXByZXNhIjoiTG9naW5zYSIsImVtYWlsIjoidHJhY2tpbmdAbG9naW5zYS5jb20iLCJjZW50cm9zIjpbIndod21zZTUiXSwiY2xpZW50ZXMiOlsiTDAwMzU3Il0sInBlcmZpbCI6IjAwMSIsImlkIjoiMWI2ZjUwMWQtMDEzMi00YzU3LWFmNzYtZmJlNDI5NDI1OTJlIiwiZXhwIjoxNzY5OTYzMzU1LCJpYXQiOjE2ODM1NjMzNTV9.FLDYUOPPlS1BsAgQWwhYjKeiOHVHz-lmj4hEcNtWRv8',
    idTrack: null,
    ordenClienteFinal: null,
    storerKey: null,
    loading: false,
    theme: null,
    hideItem: false,
    mobile: false,
    imagen: [
      //original
      {
        id: "L00357",
        url: require("@/assets/empresas/logo-Santillana.png"),
        name: "Santillana",
      },
      {
        id: "I00074",
        url: require("@/assets/empresas/undurraga.png"),
        name: "undurraga",
      },
      {
        id: "I00088",
        url: require("@/assets/empresas/just.png"),
        name: "just",
      },
      {
        id: "I00098",
        url: require("@/assets/empresas/AmaTime.png"),
        name: "AmaTime",
      },
      {
        id: "I00119",
        url: require("@/assets/empresas/paramo.png"),
        name: "Comercializadora Paramo spa",
      },
      {
        id: "I00120",
        url: require("@/assets/empresas/OSOJIROBOTICSCORPORATIONCHILESPA.png"),
        name: "OSOJI CHILE SPA",
      },
      {
        id: "I00122",
        url: require("@/assets/empresas/dnjoy.png"),
        name: "D-NJOY CHILE SPA",
      },
      {
        id: "I00123",
        url: require("@/assets/empresas/latamhair.png"),
        name: "LATAMHAIR SPA",
      },
      {
        id: "I00127",
        url: require("@/assets/empresas/prosud.jpg"),
        name: "Prosud S.A.",
      },
      {
        id: "I00128",
        url: require("@/assets/empresas/gaconfecciones.png"),
        name: "GA CONFECCIONES SPA",
      },
      {
        id: "I00143",
        url: require("@/assets/empresas/comercialchi.png"),
        name: "COMERCIAL CHI SPA",
      },
      {
        id: "I00153",
        url: require("@/assets/empresas/rebel.png"),
        name: "REBEL",
      },
      {
        id: "I00154",
        url: require("@/assets/empresas/soymomo.png"),
        name: "SOY MOMO",
      },
      {
        id: "I00163",
        url: require("@/assets/empresas/tupperware.png"),
        name: "TUPPERWARE",
      },
      {
        id: "I00069",
        url: require("@/assets/empresas/bravium.jpg"),
        name: "BRAVIUM",
      },
      {
        id: "I00157",
        url: require("@/assets/empresas/evolve.png"),
        name: "EVOLVE",
      },
      {
        id: "NATURA",
        url: require("@/assets/empresas/natura.png"),
        name: "NATURA",
      },
      {
        id: "I00174",
        url: require("@/assets/empresas/reebok.jpg"),
        name: "Reebok",
      },
      //hasta aca
      // {
      //   id: "L00223",
      //   url: require("@/assets/empresas/gasei.png"),
      //   name: "gasei",
      // },
      // {
      //   id: "I00071",
      //   url: require("@/assets/empresas/GKHAIR.png"),
      //   name: "GKHAIR",
      // },
      // {
      //   id: "I00084",
      //   url: require("@/assets/empresas/invermac.png"),
      //   name: "invermac",
      // },
      // {
      //   id: "L00444",
      //   url: require("@/assets/empresas/jeunesse.png"),
      //   name: "jeunesse",
      // },
      // {
      //   id: "I00085",
      //   url: require("@/assets/empresas/KSChileSA.png"),
      //   name: "KSChileSA",
      // },


      // {
      //   id: "I00066",
      //   url: require("@/assets/empresas/nextgen.png"),
      //   name: "nextgen",
      // },
      // {
      //   id: "I00040",
      //   url: require("@/assets/empresas/nikken.png"),
      //   name: "nikken",
      // },

      // {
      //   id: 22,
      //   url: require("@/assets/empresas/PISAFARMACEUTICACHILESA.jpg"),
      //   name: "PISAFARMACEUTICACHILESA",
      // },
      // {
      //   id: "I00063",
      //   url: require("@/assets/empresas/puroyclaro.jpg"),
      //   name: "puroyclaro",
      // },
      // {
      //   id: 24,
      //   url: require("@/assets/empresas/ripley.png"),
      //   name: "ripley",
      // },
      // {
      //   id: 25,
      //   url: require("@/assets/empresas/steward.jpg"),
      //   name: "steward",
      // },
      // {
      //   id: 26,
      //   url: require("@/assets/empresas/toyotomi.png"),
      //   name: "toyotomi",
      // },

      // {
      //   id: "I00083",
      //   url: require("@/assets/empresas/liftit.png"),
      //   name: "liftit",
      // },
      // {
      //   id: "I00070",
      //   url: require("@/assets/empresas/BELLAPIERRE.png"),
      //   name: "BELLAPIERRE",
      // },
    ],
    url: null,
    buscador: true
  },
  getters: {
    mapImagen(state) {
      return state.imagen.map(img => ({
        text: img.name.toUpperCase(),
        value: img.id,
        img: img.url,
      }));
    },
  },
  mutations: {
    setIdTrack(state, payload) {
      state.idTrack = payload;
    },
    setOrdenClienteFinal(state, payload) {
      state.ordenClienteFinal = payload;
    },
    setStorerKey(state, payload) {
      state.storerKey = payload;
    },
    mostrarLoading(state, payload) {
      state.loading.titulo = payload.titulo
      state.loading.estado = true
      state.loading.color = payload.color
    },
    ocultarLoading(state) {
      state.loading.estado = false
    },
    setTheme(state, payload) {
      state.theme = payload;
    },
    setHide(state, payload) {
      state.hideItem = payload;
    },
    setMobile(state, payload) {
      state.mobile = payload;
    },
    setImagen(state, payload) {
      state.imagen = payload;
    },
    setCuenta(state, payload) {
      state.cuenta = payload;
    },
    setUrl(state, payload) {
      state.url = payload;
    },
    setBuscador(state, payload) {
      state.buscador = payload;
    },
  },
  actions: {},
  modules: {}
});